module.exports = __webpack_public_path__ + "img/stage6.52bd020b.svg";